import { render, staticRenderFns } from "./PurchasesOrderViewDetailsPurchasesOrderItemTable.vue?vue&type=template&id=667e46aa"
import script from "./PurchasesOrderViewDetailsPurchasesOrderItemTable.vue?vue&type=script&lang=js"
export * from "./PurchasesOrderViewDetailsPurchasesOrderItemTable.vue?vue&type=script&lang=js"
import style0 from "./PurchasesOrderViewDetailsPurchasesOrderItemTable.vue?vue&type=style&index=0&id=667e46aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports